import "./style.css";

function NoResults(props) {
  return (
    <div
      className="relative flex flex-col overflow-hidden bg-darkgrey-4 w-[90%] max-w-[500px] h-[200px] max-h-[200px] ml-4 md:ml-0"
    >
      <div className="background-image flex flex-col items-center justify-center h-full">
        <div className="z-10 flex flex-col items-center justify-center">
          <div className="flex flex-col items-center py-8 md:py-[55px] px-4">
            <h1 className="font-drukwide font-[900] leading-none text-[18px] md:text-[25px] text-lightgrey uppercase text-center text-white">
              {props.skillzone
                ? "No skillzone activity found"
                : "No fixtures found"}
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
}

export default NoResults;
